import { render, staticRenderFns } from "./ConfirmSave.vue?vue&type=template&id=27a8ad90&scoped=true"
import script from "./ConfirmSave.vue?vue&type=script&lang=js"
export * from "./ConfirmSave.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSave.vue?vue&type=style&index=0&id=27a8ad90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8ad90",
  null
  
)

export default component.exports